import React, { useContext, useEffect, useReducer, useState } from "react";
import { ToastContainer } from "react-toastify";
import { useTitle, ViewCard } from "../components";
import EditModel from "./Edit";
import { useGetProfileQuery } from "../store";
import { selectAuth } from "../store/api/admin";
import { useSelector } from "react-redux";

const keyProps = {
  Email: "email",
  Fullname: "name",
  "Mobile No.": "phone",
  // Gender: "gender",
  Role: "role",
};
const View = () => {
  useTitle("Profile Details");
  const [modalShow, setModalShow] = useState(false);
  const { data, isLoading, isSuccess, error, refetch } = useGetProfileQuery();
  const user = useSelector((state) => state.adminSlice.user);
  console.log(data);
  useEffect(() => {
    refetch();
  }, [refetch]);

  return (
    <ViewCard
      title={"Profile Details"}
      data={
        user
      }
      setModalShow={setModalShow}
      keyProps={keyProps}
      isImage={true}
      image_url={user.image}
      reducerProps={{ error, isLoading, isSuccess }}
    >
      <EditModel show={modalShow} onHide={() => setModalShow(false)} />
      {!modalShow && <ToastContainer />}
    </ViewCard>
  );
};

export default View;
